import * as $ from 'jquery';
import { Map } from 'immutable';
import { AsyncSubject } from 'common/barrels/rx';

let scriptCache = Map<string, AsyncSubject<{}>>();

export function loadScriptFile(url: string, allowCache = false, init?: () => void): AsyncSubject<{}> {
    if (scriptCache.has(url))
        return scriptCache.get(url);

    const s = new AsyncSubject<{}>();

    $.ajax({
        url: url,
        dataType: 'script',
        cache: allowCache,
        success: () => {
            if (init)
                init();

            s.next({});
            s.complete();
        }
    });

    scriptCache = scriptCache.set(url, s);

    return s;
}